/** Restrict post-login redirects to our own report viewer pages. */
export function isReportReturnPath(value: unknown): value is string {
  return typeof value === "string" &&
    /^\/[a-z0-9_-]+\/reports\/[0-9a-f-]{36}\/?$/i.test(value);
}

export function reportReturnParams(value: unknown): { companySlug: string; reportId: string } | null {
  if (!isReportReturnPath(value)) return null;
  const parts = /^\/([a-z0-9_-]+)\/reports\/([0-9a-f-]{36})\/?$/i.exec(value);
  return parts ? { companySlug: parts[1]!, reportId: parts[2]! } : null;
}
